


















































































import { Component, Mixins } from 'vue-property-decorator'
import AuthMixin from '@/mixins/AuthMixin'
import ModalDialogHelper from '@/mixins/ModalDialogHelper'

import { Timestamp } from '@/firebase'

import {
	pendingInvitesForUser,
	resendInvite,
	sendInvite,
	deleteInvite
} from '@/database/invites'
// import { sharedInstance as analytics } from '@/services/AnalyticsService'

import validate from 'validate.js'
import moment from 'moment'

const InvitesInfoPanel = () => import('@/components/invites/InvitesInfoPanel.vue')

const session: { resentInvites: {[key: string]: boolean} } = {
	resentInvites: {}
}

interface PendingInvite
{
	email: string
	createdAt: firebase.firestore.Timestamp
}

@Component
export default class InvitesManagePanel extends Mixins(AuthMixin, ModalDialogHelper)
{
	private isLoading = false
	private email: string = ''
	private pendingInvites: PendingInvite[] = []

	private resentInvites = session.resentInvites

	get isEmailValid()
	{
		return this.emailIsValid(this.email)
	}

	onUserAuthed()
	{
		this.getPendingInvites()
	}

	private handleInfo()
	{
		// @ts-ignore
		this.$parent.close()

		// @ts-ignore
		const modal = this.$buefy.modal.open({
			// parent: this,
			component: InvitesInfoPanel,
			hasModalCard: true
		})

		this.bringToFront(modal)
	}

	private async getPendingInvites()
	{
		this.pendingInvites = await pendingInvitesForUser(this.signedInUser.uid)
	}

	private async handleSendInvite()
	{
		this.isLoading = true

		await sendInvite(this.email)

		this.pendingInvites.push({
			email: this.email,
			createdAt: Timestamp.now()
		})

		this.resentInvites[this.email] = true

		this.isLoading = false

		this.email = ''
	}

	private async handleResend(invite: PendingInvite)
	{
		this.isLoading = true

		await resendInvite(invite.email)

		this.resentInvites[invite.email] = true

		this.isLoading = false
	}

	private async handleDelete(invite: PendingInvite)
	{
		this.isLoading = true

		await deleteInvite(invite.email)

		const idx = this.pendingInvites.findIndex(item => item === invite)
		if (idx >= 0)
		{
			this.$delete(this.pendingInvites, idx)
		}

		this.isLoading = false
	}

	private formatDate(timestamp: firebase.firestore.Timestamp)
	{
		const date = moment.unix(timestamp.seconds)
		return date.format('MMMM Do, YYYY')
	}

	private emailIsValid(email: string | undefined)
	{
		if (!email)
		{
			email = this.email
		}

		if (!email)
		{
			return
		}

		const result = validate({ from: email }, {
			from: {
				email: true
			}
		})

		if (result === undefined)
		{
			return true
		}

		return false
	}
}

